module.exports = __webpack_public_path__ + "static/media/efficacy.2f5d47a2.svg";